import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './vuerouter'
import store from '../store/store'
import dotenv from 'dotenv'
dotenv.config()
//form validation
import VuePapaParse from 'vue-papa-parse'
import Vuelidate from 'vuelidate'

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

Vue.use(VueToast)

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(VueQuillEditor, /* { default global options } */)


Vue.use(VuePapaParse)  // CSV File parsing
Vue.use(Vuelidate) // Form validation

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
